/**
 * Shared Jobs Service
 * Jobs service for cross-feature job creation
 * Source: features/jobs - extracted for cross-feature use
 */
import { AxiosResponse } from "axios";
import axiosInstance from "@/axiosConfig";
import type { JobServiceResponse } from "@/shared/types/job.types";
import { getApiUrl } from "@/shared/utils/api";

const JOBS_ENDPOINT = "/jobs";
const VOUCHER_ORDER_ENDPOINT = "/voucher_orders";

/** Job types for file uploads */
type FileUploadJobType = "UPLOAD FICHIER" | "UPLOAD FICHIER SITE" | "UPLOAD FICHIER TITRES" | "UPLOAD FICHIER CATEGORIES" | "UPLOAD FICHIER LOTS TOMBOLA";

/** Job types for voucher creation */
type VoucherJobType = "CREATION BON DE COMMANDE";

/** Base job params */
type BaseJobParams = {
  type: FileUploadJobType
  signedId: string
  params?: Record<string, unknown>
};

/** Voucher job params */
type VoucherJobParams = {
  type: VoucherJobType
  params: Record<string, unknown>
};

type CreateJobParams = BaseJobParams;
type CreateVoucherJobParams = VoucherJobParams;

/**
 * Create a job (file upload, import, etc.)
 */
export const postJob = async (data: CreateJobParams): Promise<AxiosResponse<JobServiceResponse>> => {
  const body = {
    data: {
      attributes: {
        "resource": data.type,
        "job-piece": data.signedId,
        ...(data.params ?? {}),
      },
    },
  };

  return axiosInstance.post<JobServiceResponse>(getApiUrl(JOBS_ENDPOINT), body);
};

/**
 * Create a voucher order job
 */
export const postJobToCreateVoucher = async (data: CreateVoucherJobParams): Promise<AxiosResponse<JobServiceResponse>> => {
  const body = {
    data: {
      attributes: {
        resource: data.type,
        ...data.params,
      },
    },
  };

  return axiosInstance.post<JobServiceResponse>(getApiUrl(VOUCHER_ORDER_ENDPOINT), body);
};
